import React, { Fragment } from "react";

import { DeviceDropdownMenu } from "../../../../../../../components/devices/DeviceDropdownMenu";
import { DeviceActionsToggle } from "../../../../../../../components/devices/DeviceActionsDialog";
import { Mobile, NotMobile } from "../../../../../../../hocs/Responsive";
import {
  MergeDeviceDropdownItem,
  MergeDeviceModalItem,
} from "../../../../../../../components/devices/mergeDeviceItem";
import {
  AssignDeviceDropdownItem,
  AssignDeviceModalItem,
} from "../../../../../../../components/devices/assignDeviceItem";
import {
  BlockDeviceDropdownItem,
  BlockDeviceModalItem,
} from "../../../../../../../components/devices/blockDeviceItem";

export const OnlineDevicesDropdownActions = ({
  identifier,
  type,
  manufacturer,
}) => {
  const dropdownItems = [
    <MergeDeviceDropdownItem deviceToMerge={{ id: identifier, type }} />,
    <AssignDeviceDropdownItem
      device={{ identifiers: [identifier], type }}
      messageId={"assign_to_group"}
    />,
    <BlockDeviceDropdownItem
      device={{ identifiers: [identifier], type, manufacturer }}
    />,
  ];

  const modalItems = [
    <MergeDeviceModalItem deviceToMerge={{ id: identifier, type }} />,
    <AssignDeviceModalItem
      device={{ identifiers: [identifier], type }}
      messageId={"assign_to_group"}
    />,
    <BlockDeviceModalItem
      device={{ identifiers: [identifier], type, manufacturer }}
    />,
  ];

  return (
    <Fragment>
      <Mobile>
        <DeviceActionsToggle deviceName={identifier} menuItems={modalItems} />
      </Mobile>
      <NotMobile>
        <DeviceDropdownMenu menuItems={dropdownItems} />
      </NotMobile>
    </Fragment>
  );
};
